import { Component, OnInit } from '@angular/core';
import { VerifyUserComponent } from '../../components/verify-user/verify-user.component';

@Component({
    selector: 'verify-user.container',
    templateUrl: './verify-user.container.component.html',
    imports: [
        VerifyUserComponent
    ]
})

export class VerifyUserContainerComponent implements OnInit {
    constructor() { }

    ngOnInit(): void { }
}